import React              from 'react';
import PropTypes          from 'prop-types';
import { Button, Popup }  from 'semantic-ui-react';
import { Link }           from 'react-router-dom';

// -----------------------------------------------------
// Settings
// -----------------------------------------------------

const title = 'Open record.';

// -----------------------------------------------------
// Component Definition
// -----------------------------------------------------

const ShowButton = ({ formId, recordId }) => {
  const href =
    `/organization/internal_form_responses/${formId}/records/${recordId}`;

  const Btn = <Button icon='eye'
                      basic
                      color='blue'
                      as={ Link }
                      to={ href } />;

  return (
    <Popup  trigger={ Btn }
            content={ title }
            position='top center' />
  );
};

// -----------------------------------------------------
// PropTypes
// -----------------------------------------------------

ShowButton.propTypes = {
  formId:   PropTypes.number.isRequired,
  recordId: PropTypes.number.isRequired
};

// -----------------------------------------------------
// Exports
// -----------------------------------------------------

export default ShowButton;
